import React, { useRef, useState } from 'react';
import classnames from 'classnames';
import { FormattedMessage, IntlShape } from 'react-intl';
import ChevronSVG from '../../../../../../images/svg/icons8-expand-arrow';
import { Popover } from '../../../../../global/popover/popover';
import Text from '../../../../../global/text/text';
import { SearchInput } from '../../../../../global/search-input/search-input';
import { IEntityRoleDTO } from '../../../../../../api/events.dao';
interface IDeliveryTeamRoleProps {
    intl: IntlShape;
    username: string;
    deliveryMemberRoles: IEntityRoleDTO[];
    setDeliveryMemberRole: (username: string, role: string) => void;
    deliveryMemberRole?: string;
    shouldRenderIcon: boolean;
    customPopoverWidth?: number;
    customLeft?: number;
}

const DeliveryTeamRole = (props: IDeliveryTeamRoleProps) => {
    const {
        deliveryMemberRole,
        deliveryMemberRoles,
        setDeliveryMemberRole,
        username,
        intl,
        shouldRenderIcon,
        customPopoverWidth,
        customLeft,
    } = props;
    const roleButtonRef = useRef(null);
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const [filteredItems, setFilteredItems] = useState<IEntityRoleDTO[]>(deliveryMemberRoles);
    const shouldDisabledItems = shouldRenderIcon === false;

    const handleSearchRole = (searchValue: string) => {
        const newItems = deliveryMemberRoles.filter(item => item.label.toLowerCase().indexOf(searchValue.trim().toLowerCase()) !== -1);
        if (!searchValue) {
            setFilteredItems(deliveryMemberRoles);
        } else {
            setFilteredItems(newItems);
        }
    };

    const handleOptionClick = (id: string, optionValue: string) => {
        setDeliveryMemberRole(id, optionValue);
        setFilteredItems(deliveryMemberRoles);
        setIsModalOpen(false);
    };

    return (
        <div
            className={classnames('item-role', {
                'item-role--selected': deliveryMemberRole && !shouldDisabledItems,
                'item-role--active': isModalOpen,
                'item-role--disabled': shouldDisabledItems,
            })}
            ref={roleButtonRef}
            onClick={!shouldDisabledItems ? () => setIsModalOpen(prevState => !prevState) : undefined}
        >
            <div
                className='item-role__label'
            >
                <Text
                    message={deliveryMemberRole
                            ? intl.formatMessage({
                                id: `oe.deliveryTeamMemberRole.${deliveryMemberRole}`,
                            })
                            : shouldDisabledItems ? ''
                            : intl.formatMessage({
                                id: 'oe.common.assignRole',
                                description: 'Role option',
                                defaultMessage: 'Assign role...',
                            })}
                    withEllipsis
                />
                {!shouldDisabledItems && <ChevronSVG />}
            </div>
            <Popover
                padding={0}
                isOpen={isModalOpen}
                buttonRef={roleButtonRef}
                onClickOutside={() => setIsModalOpen(false)}
                customWidth={customPopoverWidth || roleButtonRef.current?.getBoundingClientRect().width}
                customLeft={customLeft}
            >
                <div className='item-role__dropdown--wrapper'>
                    <SearchInput onChange={e => handleSearchRole(e.target.value)} autoFocus={true} />

                    <div className='item-role__dropdown--options'>
                        {filteredItems.length ? (
                            filteredItems.map(({ id }) => (
                                <div
                                    key={id}
                                    className={classnames('item-role__dropdown--option', {
                                        'item-role__dropdown--option--selected': id === deliveryMemberRole
                                    })}
                                    onClick={e => {
                                        e.stopPropagation();
                                        handleOptionClick(username, id);
                                    }}
                                >
                                    <FormattedMessage
                                        id={`oe.deliveryTeamMemberRole.${id}`}
                                        description='Operator role option'
                                    />
                                </div>
                            ))
                        ) : (
                            <div className='item-role__dropdown--option item-role__dropdown--option__empty'>
                                {intl.formatMessage({
                                    id: 'oe.items.noMatchingSearchCriteria',
                                    description: 'Label text',
                                    defaultMessage: 'No items matching search criteria'
                                })}
                            </div>
                        )}
                    </div>
                </div>
            </Popover>
        </div>
    );
};

export { DeliveryTeamRole };
